import React, { useEffect, useState } from 'react'

import {
  BlockVacancies,
  FiveSteps,
  OurIdea,
  OurLocation,
  OurProduction,
  PersonalGenerium,
  SearchJobs,
  TeachWithGenerium,
  UsefulInformation,
  WhyGenerium,
  RunningString,
  Rating,
  WeInMedia,
  PartOfTeamForm,
  OurValue
} from '../index'
//import photo from '../../../images/main/stage__img.png'
//import photo480 from '../../../images/main/stage__img480.jpg'

import styles from './styles.module.scss'
import smoothscroll from 'smoothscroll-polyfill'

const Main = ({ filterVacation, listAdvantage, setSearchMainInput, searchMainInput, ourRef, checkDomenNameState, captchaSiteKey }) => {
  smoothscroll.polyfill()
  const [checkRef, setCheckRef] = useState('')

  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])

  return (
    <div>
      <div className={styles.wrapper} id="content">
        <div>
          <SearchJobs
            filterVacation={filterVacation}
            setSearchMainInput={setSearchMainInput}
            searchMainInput={searchMainInput}
          />
          <OurIdea />
          <OurValue />
          <OurProduction />
          <WhyGenerium listAdvantage={listAdvantage}/>
          <Rating />
          <WeInMedia checkDomenNameState={checkDomenNameState} />
          <OurLocation />
          {/* <BlockVacancies filterVacation={filterVacation} /> */}
          <FiveSteps />
          <PersonalGenerium />
          <TeachWithGenerium />
          <UsefulInformation />
          <PartOfTeamForm checkDomenNameState={checkDomenNameState} setCheckRef={setCheckRef} captchaSiteKey={captchaSiteKey} />
          <RunningString />
        </div>
      </div>
    </div>
  )
}

export default Main
